export default __webpack_public_path__ + "static/media/system-down.e5199dce.png";